// src/checkDigit.ts
var WEIGHTS = [7, 3, 1];
function charValue(c) {
  if (c === "<") return 0;
  const code = c.charCodeAt(0);
  if (code >= 48 && code <= 57) return code - 48;
  if (code >= 65 && code <= 90) return code - 55;
  return -1;
}
function computeCheckDigit(data) {
  let sum = 0;
  for (let i = 0; i < data.length; i++) {
    const v = charValue(data[i]);
    if (v < 0) return null;
    sum += v * WEIGHTS[i % 3];
  }
  return sum % 10;
}
function isValidCheckDigit(data, digit) {
  if (digit === "<") return /^<*$/.test(data);
  if (!/^[0-9]$/.test(digit)) return false;
  return computeCheckDigit(data) === Number(digit);
}

// src/data/countries.ts
var ISO_COUNTRIES = {
  ABW: "Aruba",
  AFG: "Afghanistan",
  AGO: "Angola",
  AIA: "Anguilla",
  ALA: "\xC5land Islands",
  ALB: "Albania",
  AND: "Andorra",
  ARE: "United Arab Emirates",
  ARG: "Argentina",
  ARM: "Armenia",
  ASM: "American Samoa",
  ATA: "Antarctica",
  ATF: "French Southern Territories",
  ATG: "Antigua and Barbuda",
  AUS: "Australia",
  AUT: "Austria",
  AZE: "Azerbaijan",
  BDI: "Burundi",
  BEL: "Belgium",
  BEN: "Benin",
  BES: "Bonaire, Sint Eustatius and Saba",
  BFA: "Burkina Faso",
  BGD: "Bangladesh",
  BGR: "Bulgaria",
  BHR: "Bahrain",
  BHS: "Bahamas",
  BIH: "Bosnia and Herzegovina",
  BLM: "Saint Barth\xE9lemy",
  BLR: "Belarus",
  BLZ: "Belize",
  BMU: "Bermuda",
  BOL: "Bolivia",
  BRA: "Brazil",
  BRB: "Barbados",
  BRN: "Brunei Darussalam",
  BTN: "Bhutan",
  BVT: "Bouvet Island",
  BWA: "Botswana",
  CAF: "Central African Republic",
  CAN: "Canada",
  CCK: "Cocos (Keeling) Islands",
  CHE: "Switzerland",
  CHL: "Chile",
  CHN: "People's Republic of China",
  CIV: "Cote d'Ivoire",
  CMR: "Cameroon",
  COD: "Democratic Republic of the Congo",
  COG: "Republic of the Congo",
  COK: "Cook Islands",
  COL: "Colombia",
  COM: "Comoros",
  CPV: "Cape Verde",
  CRI: "Costa Rica",
  CUB: "Cuba",
  CUW: "Cura\xE7ao",
  CXR: "Christmas Island",
  CYM: "Cayman Islands",
  CYP: "Cyprus",
  CZE: "Czech Republic",
  DEU: "Germany",
  DJI: "Djibouti",
  DMA: "Dominica",
  DNK: "Denmark",
  DOM: "Dominican Republic",
  DZA: "Algeria",
  ECU: "Ecuador",
  EGY: "Egypt",
  ERI: "Eritrea",
  ESH: "Western Sahara",
  ESP: "Spain",
  EST: "Estonia",
  ETH: "Ethiopia",
  FIN: "Finland",
  FJI: "Fiji",
  FLK: "Falkland Islands (Malvinas)",
  FRA: "France",
  FRO: "Faroe Islands",
  FSM: "Micronesia, Federated States of",
  GAB: "Gabon",
  GBR: "United Kingdom",
  GEO: "Georgia",
  GGY: "Guernsey",
  GHA: "Ghana",
  GIB: "Gibraltar",
  GIN: "Guinea",
  GLP: "Guadeloupe",
  GMB: "Republic of The Gambia",
  GNB: "Guinea-Bissau",
  GNQ: "Equatorial Guinea",
  GRC: "Greece",
  GRD: "Grenada",
  GRL: "Greenland",
  GTM: "Guatemala",
  GUF: "French Guiana",
  GUM: "Guam",
  GUY: "Guyana",
  HKG: "Hong Kong",
  HMD: "Heard Island and McDonald Islands",
  HND: "Honduras",
  HRV: "Croatia",
  HTI: "Haiti",
  HUN: "Hungary",
  IDN: "Indonesia",
  IMN: "Isle of Man",
  IND: "India",
  IOT: "British Indian Ocean Territory",
  IRL: "Ireland",
  IRN: "Islamic Republic of Iran",
  IRQ: "Iraq",
  ISL: "Iceland",
  ISR: "Israel",
  ITA: "Italy",
  JAM: "Jamaica",
  JEY: "Jersey",
  JOR: "Jordan",
  JPN: "Japan",
  KAZ: "Kazakhstan",
  KEN: "Kenya",
  KGZ: "Kyrgyzstan",
  KHM: "Cambodia",
  KIR: "Kiribati",
  KNA: "Saint Kitts and Nevis",
  KOR: "South Korea",
  KWT: "Kuwait",
  LAO: "Lao People's Democratic Republic",
  LBN: "Lebanon",
  LBR: "Liberia",
  LBY: "Libya",
  LCA: "Saint Lucia",
  LIE: "Liechtenstein",
  LKA: "Sri Lanka",
  LSO: "Lesotho",
  LTU: "Lithuania",
  LUX: "Luxembourg",
  LVA: "Latvia",
  MAC: "Macao",
  MAF: "Saint Martin (French part)",
  MAR: "Morocco",
  MCO: "Monaco",
  MDA: "Moldova, Republic of",
  MDG: "Madagascar",
  MDV: "Maldives",
  MEX: "Mexico",
  MHL: "Marshall Islands",
  MKD: "The Republic of North Macedonia",
  MLI: "Mali",
  MLT: "Malta",
  MMR: "Myanmar",
  MNE: "Montenegro",
  MNG: "Mongolia",
  MNP: "Northern Mariana Islands",
  MOZ: "Mozambique",
  MRT: "Mauritania",
  MSR: "Montserrat",
  MTQ: "Martinique",
  MUS: "Mauritius",
  MWI: "Malawi",
  MYS: "Malaysia",
  MYT: "Mayotte",
  NAM: "Namibia",
  NCL: "New Caledonia",
  NER: "Niger",
  NFK: "Norfolk Island",
  NGA: "Nigeria",
  NIC: "Nicaragua",
  NIU: "Niue",
  NLD: "Netherlands",
  NOR: "Norway",
  NPL: "Nepal",
  NRU: "Nauru",
  NZL: "New Zealand",
  OMN: "Oman",
  PAK: "Pakistan",
  PAN: "Panama",
  PCN: "Pitcairn",
  PER: "Peru",
  PHL: "Philippines",
  PLW: "Palau",
  PNG: "Papua New Guinea",
  POL: "Poland",
  PRI: "Puerto Rico",
  PRK: "North Korea",
  PRT: "Portugal",
  PRY: "Paraguay",
  PSE: "State of Palestine",
  PYF: "French Polynesia",
  QAT: "Qatar",
  REU: "Reunion",
  ROU: "Romania",
  RUS: "Russian Federation",
  RWA: "Rwanda",
  SAU: "Saudi Arabia",
  SDN: "Sudan",
  SEN: "Senegal",
  SGP: "Singapore",
  SGS: "South Georgia and the South Sandwich Islands",
  SHN: "Saint Helena",
  SJM: "Svalbard and Jan Mayen",
  SLB: "Solomon Islands",
  SLE: "Sierra Leone",
  SLV: "El Salvador",
  SMR: "San Marino",
  SOM: "Somalia",
  SPM: "Saint Pierre and Miquelon",
  SRB: "Serbia",
  SSD: "South Sudan",
  STP: "Sao Tome and Principe",
  SUR: "Suriname",
  SVK: "Slovakia",
  SVN: "Slovenia",
  SWE: "Sweden",
  SWZ: "Eswatini",
  SXM: "Sint Maarten (Dutch part)",
  SYC: "Seychelles",
  SYR: "Syrian Arab Republic",
  TCA: "Turks and Caicos Islands",
  TCD: "Chad",
  TGO: "Togo",
  THA: "Thailand",
  TJK: "Tajikistan",
  TKL: "Tokelau",
  TKM: "Turkmenistan",
  TLS: "Timor-Leste",
  TON: "Tonga",
  TTO: "Trinidad and Tobago",
  TUN: "Tunisia",
  TUR: "T\xFCrkiye",
  TUV: "Tuvalu",
  TWN: "Taiwan, Province of China",
  TZA: "United Republic of Tanzania",
  UGA: "Uganda",
  UKR: "Ukraine",
  UMI: "United States Minor Outlying Islands",
  URY: "Uruguay",
  USA: "United States of America",
  UZB: "Uzbekistan",
  VAT: "Holy See (Vatican City State)",
  VCT: "Saint Vincent and the Grenadines",
  VEN: "Venezuela",
  VGB: "Virgin Islands, British",
  VIR: "Virgin Islands, U.S.",
  VNM: "Vietnam",
  VUT: "Vanuatu",
  WLF: "Wallis and Futuna",
  WSM: "Samoa",
  XKK: "Kosovo",
  YEM: "Yemen",
  ZAF: "South Africa",
  ZMB: "Zambia",
  ZWE: "Zimbabwe"
};

// src/countries.ts
var ICAO_SPECIAL_CODES = {
  D: "Germany",
  GBD: "British Overseas Territories Citizen",
  GBN: "British National (Overseas)",
  GBO: "British Overseas Citizen",
  GBP: "British Protected Person",
  GBS: "British Subject",
  UNO: "United Nations Organization",
  UNA: "Specialized agency of the United Nations",
  UNK: "Resident of Kosovo (UNMIK travel document)",
  RKS: "Kosovo",
  EUE: "European Union",
  XOM: "Sovereign Military Order of Malta",
  XPO: "International Criminal Police Organization (INTERPOL)",
  XBA: "African Development Bank",
  XIM: "African Export-Import Bank",
  XCC: "Caribbean Community (CARICOM)",
  XCE: "Council of Europe",
  XCO: "Common Market for Eastern and Southern Africa (COMESA)",
  XEC: "Economic Community of West African States (ECOWAS)",
  XDC: "Southern African Development Community (SADC)",
  XES: "Organisation of Eastern Caribbean States (OECS)",
  XXA: "Stateless person",
  XXB: "Refugee (1951 Convention)",
  XXC: "Refugee (other)",
  XXX: "Unspecified nationality",
  UTO: "Utopia (ICAO specimen state)"
};
function lookupCountry(raw) {
  const code = raw.replace(/<+$/, "");
  const special = ICAO_SPECIAL_CODES[code];
  if (special) return { code, name: special, kind: "icao" };
  const iso = ISO_COUNTRIES[code];
  if (iso) return { code, name: iso, kind: "iso" };
  return { code, name: null, kind: "unknown" };
}
function isKnownCountry(raw) {
  return lookupCountry(raw).kind !== "unknown";
}

// src/formats.ts
var f = (name, line, start, length, cls) => ({
  name,
  line,
  start,
  length,
  cls
});
var fieldChecks = [
  { name: "documentNumber", field: "documentNumber", digit: "documentNumberCheckDigit" },
  { name: "birthDate", field: "birthDate", digit: "birthDateCheckDigit" },
  { name: "expiryDate", field: "expiryDate", digit: "expiryDateCheckDigit" }
];
var line2Common = (line) => [
  f("documentNumber", line, 0, 9, "alnum"),
  f("documentNumberCheckDigit", line, 9, 1, "digit"),
  f("nationality", line, 10, 3, "alpha"),
  f("birthDate", line, 13, 6, "digit"),
  f("birthDateCheckDigit", line, 19, 1, "digit"),
  f("sex", line, 20, 1, "alpha"),
  f("expiryDate", line, 21, 6, "digit"),
  f("expiryDateCheckDigit", line, 27, 1, "digit")
];
var line1Name = (length) => [
  f("documentCode", 0, 0, 2, "alpha"),
  f("issuingState", 0, 2, 3, "alpha"),
  f("name", 0, 5, length, "alpha")
];
var LAYOUTS = {
  TD3: {
    format: "TD3",
    lineCount: 2,
    lineLength: 44,
    fields: [
      ...line1Name(39),
      ...line2Common(1),
      f("personalNumber", 1, 28, 14, "alnum"),
      f("personalNumberCheckDigit", 1, 42, 1, "digit"),
      f("compositeCheckDigit", 1, 43, 1, "digit")
    ],
    checks: [
      ...fieldChecks,
      { name: "personalNumber", field: "personalNumber", digit: "personalNumberCheckDigit" },
      {
        name: "composite",
        digit: "compositeCheckDigit",
        ranges: [
          [1, 0, 10],
          [1, 13, 20],
          [1, 21, 43]
        ]
      }
    ]
  },
  TD2: {
    format: "TD2",
    lineCount: 2,
    lineLength: 36,
    fields: [
      ...line1Name(31),
      ...line2Common(1),
      f("optionalData1", 1, 28, 7, "alnum"),
      f("compositeCheckDigit", 1, 35, 1, "digit")
    ],
    checks: [
      ...fieldChecks,
      {
        name: "composite",
        digit: "compositeCheckDigit",
        ranges: [
          [1, 0, 10],
          [1, 13, 20],
          [1, 21, 35]
        ]
      }
    ]
  },
  TD1: {
    format: "TD1",
    lineCount: 3,
    lineLength: 30,
    fields: [
      f("documentCode", 0, 0, 2, "alpha"),
      f("issuingState", 0, 2, 3, "alpha"),
      f("documentNumber", 0, 5, 9, "alnum"),
      f("documentNumberCheckDigit", 0, 14, 1, "digit"),
      f("optionalData1", 0, 15, 15, "alnum"),
      f("birthDate", 1, 0, 6, "digit"),
      f("birthDateCheckDigit", 1, 6, 1, "digit"),
      f("sex", 1, 7, 1, "alpha"),
      f("expiryDate", 1, 8, 6, "digit"),
      f("expiryDateCheckDigit", 1, 14, 1, "digit"),
      f("nationality", 1, 15, 3, "alpha"),
      f("optionalData2", 1, 18, 11, "alnum"),
      f("compositeCheckDigit", 1, 29, 1, "digit"),
      f("name", 2, 0, 30, "alpha")
    ],
    checks: [
      ...fieldChecks,
      {
        name: "composite",
        digit: "compositeCheckDigit",
        ranges: [
          [0, 5, 30],
          [1, 0, 7],
          [1, 8, 15],
          [1, 18, 29]
        ]
      }
    ]
  },
  MRVA: {
    format: "MRVA",
    lineCount: 2,
    lineLength: 44,
    fields: [...line1Name(39), ...line2Common(1), f("optionalData1", 1, 28, 16, "alnum")],
    checks: fieldChecks
  },
  MRVB: {
    format: "MRVB",
    lineCount: 2,
    lineLength: 36,
    fields: [...line1Name(31), ...line2Common(1), f("optionalData1", 1, 28, 8, "alnum")],
    checks: fieldChecks
  }
};
function fieldDef(layout, name) {
  return layout.fields.find((d) => d.name === name);
}
function readField(lines, def) {
  return (lines[def.line] ?? "").slice(def.start, def.start + def.length);
}

// src/correct.ts
var DIGIT_FOR_LETTER = {
  O: "0",
  D: "0",
  Q: "0",
  I: "1",
  L: "1",
  Z: "2",
  S: "5",
  G: "6",
  B: "8"
};
var LETTERS_FOR_DIGIT = {
  "0": ["O", "D"],
  "1": ["I"],
  "2": ["Z"],
  "5": ["S"],
  "6": ["G"],
  "8": ["B"]
};
var isDigit = (c) => c >= "0" && c <= "9";
var isLetter = (c) => c >= "A" && c <= "Z";
function alternatives(c, cls) {
  if (cls === "digit") return isLetter(c) && DIGIT_FOR_LETTER[c] ? [DIGIT_FOR_LETTER[c]] : [];
  if (cls === "alpha") return isDigit(c) ? [...LETTERS_FOR_DIGIT[c] ?? []] : [];
  if (isDigit(c)) return [...LETTERS_FOR_DIGIT[c] ?? []];
  if (isLetter(c)) {
    const alts = DIGIT_FOR_LETTER[c] ? [DIGIT_FOR_LETTER[c]] : [];
    if (c === "K") alts.push("<");
    return alts;
  }
  return [];
}
function positions(line, start, end) {
  const out = [];
  for (let i = start; i < end; i++) out.push([line, i]);
  return out;
}
function resolveCheck(layout, check, lines) {
  const digitDef = fieldDef(layout, check.digit);
  if (!digitDef) return null;
  const digit = [digitDef.line, digitDef.start];
  if (check.ranges) {
    const covered2 = check.ranges.flatMap(([l, s, e]) => positions(l, s, e));
    return { name: check.name, field: check.digit, covered: covered2, digit, longDocumentNumber: false };
  }
  const def = fieldDef(layout, check.field);
  if (!def) return null;
  const covered = positions(def.line, def.start, def.start + def.length);
  if (check.name === "documentNumber" && (layout.format === "TD1" || layout.format === "TD2")) {
    const line = lines[digit[0]] ?? "";
    const opt = fieldDef(layout, "optionalData1");
    const optText = readField(lines, opt);
    const end = optText.indexOf("<");
    if (line[digit[1]] === "<" && end !== 0 && (end < 0 ? optText.length : end) >= 2) {
      const len = end < 0 ? optText.length : end;
      return {
        name: check.name,
        field: check.field,
        covered: [...covered, ...positions(opt.line, opt.start, opt.start + len - 1)],
        digit: [opt.line, opt.start + len - 1],
        longDocumentNumber: true
      };
    }
  }
  return { name: check.name, field: check.field, covered, digit, longDocumentNumber: false };
}
var at = (g, p) => g[p[0]][p[1]];
function checkPasses(g, rc) {
  return isValidCheckDigit(rc.covered.map((p) => at(g, p)).join(""), at(g, rc.digit));
}
function applyChanges(g, changes) {
  for (const c of changes) g[c.line][c.position] = c.to;
}
function revertChanges(g, changes) {
  for (const c of changes) g[c.line][c.position] = c.from;
}
var SEARCH_BUDGET = 2e5;
function searchCheck(g, rc, classAt, maxK, frozen = /* @__PURE__ */ new Set()) {
  if (checkPasses(g, rc)) return [[]];
  const slots = [...rc.covered, rc.digit].filter((p) => !frozen.has(`${p[0]}:${p[1]}`)).map((p) => ({ p, alts: alternatives(at(g, p), p === rc.digit ? "digit" : classAt(p)) })).filter((s) => s.alts.length > 0);
  let budget = SEARCH_BUDGET;
  for (let k = 1; k <= Math.min(maxK, slots.length); k++) {
    const found = [];
    const chosen = [];
    const recurse = (startSlot) => {
      if (budget <= 0) return;
      if (chosen.length === k) {
        budget--;
        applyChanges(g, chosen);
        if (checkPasses(g, rc)) found.push([...chosen]);
        revertChanges(g, chosen);
        return;
      }
      for (let i = startSlot; i < slots.length; i++) {
        const { p, alts } = slots[i];
        for (const to of alts) {
          chosen.push({ line: p[0], position: p[1], from: at(g, p), to });
          recurse(i + 1);
          chosen.pop();
        }
      }
    };
    recurse(0);
    if (found.length) return found;
  }
  return [];
}
function correctLines(inputLines, layout, maxK = 2) {
  const g = inputLines.map((l) => [...l]);
  const log = [];
  const warnings = [];
  const ambiguities = [];
  const commit = (changes, reason) => {
    applyChanges(g, changes);
    for (const change of changes) log.push({ change, reason });
  };
  const lines = () => g.map((r) => r.join(""));
  const classes = g.map((r) => r.map(() => "alnum"));
  for (const d of layout.fields)
    for (let i = 0; i < d.length; i++) classes[d.line][d.start + i] = d.cls;
  const classAt = (p) => classes[p[0]][p[1]];
  for (const d of layout.fields) {
    if (d.cls !== "alnum" && d.name !== "name") continue;
    const value = readField(lines(), d);
    const fillers = value.replace(/[^<]/g, "").length;
    const allFiller = d.name !== "name" && /^<[<KL]*$/.test(value) && fillers > value.length - fillers;
    const run = allFiller ? 0 : value.indexOf(d.name === "name" ? "<<<" : "<<");
    if (run < 0) continue;
    const tail = value.slice(run);
    if (!/^[<KLXCE]*$/.test(tail) || d.name !== "name" && !/^[<KL]*$/.test(tail)) continue;
    const changes = [];
    for (let i = run; i < value.length; i++) {
      if (value[i] !== "<")
        changes.push({ line: d.line, position: d.start + i, from: value[i], to: "<" });
    }
    commit(changes, "filler");
  }
  for (const d of layout.fields) {
    if (d.name === "sex") continue;
    const value = readField(lines(), d);
    if (d.name === "issuingState" || d.name === "nationality") {
      if (!/[0-9]/.test(value)) continue;
      let options = [""];
      for (const c of value) {
        const alts = isDigit(c) ? LETTERS_FOR_DIGIT[c] ?? [c] : [c];
        options = options.flatMap((o) => alts.map((a) => o + a));
      }
      const known = options.filter((o) => isKnownCountry(o));
      if (known.length === 1) {
        const target = known[0];
        const changes2 = [];
        for (let i = 0; i < value.length; i++) {
          if (value[i] !== target[i])
            changes2.push({ line: d.line, position: d.start + i, from: value[i], to: target[i] });
        }
        commit(changes2, "character-class");
      }
      continue;
    }
    const changes = [];
    for (let i = 0; i < value.length; i++) {
      const c = value[i];
      let to;
      if (d.cls === "digit" && isLetter(c)) to = DIGIT_FOR_LETTER[c];
      else if (d.cls === "alpha" && isDigit(c)) to = LETTERS_FOR_DIGIT[c]?.[0];
      if (to) changes.push({ line: d.line, position: d.start + i, from: c, to });
    }
    commit(changes, "character-class");
  }
  const fieldChecks2 = layout.checks.filter((c) => !c.ranges);
  const compositeDef = layout.checks.find((c) => c.ranges);
  const failing = [];
  for (const check of fieldChecks2) {
    const rc = resolveCheck(layout, check, lines());
    if (!rc || checkPasses(g, rc)) continue;
    failing.push({ rc, cands: searchCheck(g, rc, classAt, maxK) });
  }
  const fieldValue = (rc, changes) => {
    applyChanges(g, changes);
    const v = rc.covered.map((p) => at(g, p)).join("");
    revertChanges(g, changes);
    return v;
  };
  const reportAmbiguous = (rc, cands) => {
    const candidates = [...new Set(cands.map((c) => fieldValue(rc, c)))];
    const original2 = fieldValue(rc, []);
    ambiguities.push({ check: rc.name, field: rc.field, original: original2, candidates });
    warnings.push({
      code: "correction_ambiguous",
      field: rc.field,
      message: `Check digit for ${rc.field} fails and ${candidates.length} different corrections (${candidates.slice(0, 5).join(", ")}${candidates.length > 5 ? ", \u2026" : ""}) would fix it; none was applied.`
    });
  };
  const solvable = failing.filter((f2) => f2.cands.length > 0);
  const compositeRc = compositeDef ? resolveCheck(layout, compositeDef, lines()) : null;
  const multi = solvable.filter((f2) => f2.cands.length > 1);
  if (multi.length && compositeRc) {
    let combos = [[]];
    for (const f2 of solvable) {
      combos = combos.flatMap((combo) => f2.cands.map((c) => [...combo, c]));
      if (combos.length > 2e4) break;
    }
    const passing = combos.length <= 2e4 ? combos.filter((combo) => {
      const all = combo.flat();
      applyChanges(g, all);
      const ok = checkPasses(g, compositeRc);
      revertChanges(g, all);
      return ok;
    }) : [];
    if (passing.length === 1) {
      passing[0].forEach(
        (changes, i) => commit(changes, solvable[i].cands.length > 1 ? "check-digit+composite" : "check-digit")
      );
    } else {
      for (const f2 of solvable) {
        if (f2.cands.length === 1) commit(f2.cands[0], "check-digit");
        else reportAmbiguous(f2.rc, f2.cands);
      }
    }
  } else {
    for (const f2 of solvable) {
      if (f2.cands.length === 1) commit(f2.cands[0], "check-digit");
      else reportAmbiguous(f2.rc, f2.cands);
    }
  }
  if (compositeRc && !checkPasses(g, compositeRc)) {
    const current = lines();
    const allFieldChecksPass = layout.checks.filter((c) => !c.ranges).every((c) => {
      const rc = resolveCheck(layout, c, current);
      return !rc || checkPasses(g, rc);
    });
    if (allFieldChecksPass) {
      const frozen = /* @__PURE__ */ new Set();
      for (const c of fieldChecks2) {
        const rc = resolveCheck(layout, c, current);
        if (rc) for (const p of [...rc.covered, rc.digit]) frozen.add(`${p[0]}:${p[1]}`);
      }
      const cands = searchCheck(g, compositeRc, classAt, maxK, frozen);
      if (cands.length === 1 && cands[0].length) {
        commit(cands[0], "composite");
        warnings.push({
          code: "correction_composite_only",
          message: "A correction was made using only the composite check digit; verify the optional data against the document."
        });
      } else if (cands.length > 1) {
        reportAmbiguous({ ...compositeRc, field: "compositeCheckDigit" }, cands);
      }
    }
  }
  const corrections = [];
  const original = inputLines;
  const final = lines();
  for (const d of layout.fields) {
    const entries = log.filter(
      (e) => e.change.line === d.line && e.change.position >= d.start && e.change.position < d.start + d.length
    );
    if (!entries.length) continue;
    const before = readField(original, d);
    const after = readField(final, d);
    if (before === after) continue;
    const changes = entries.map((e) => e.change).filter(
      (c, i, arr) => arr.findLastIndex((x) => x.position === c.position && x.line === c.line) === i
    ).map((c) => ({ ...c, from: original[c.line][c.position] })).filter((c) => c.from !== c.to);
    corrections.push({
      field: d.name,
      reason: entries[entries.length - 1].reason,
      original: before,
      corrected: after,
      changes
    });
  }
  return { lines: final, corrections, ambiguities, warnings };
}

export {
  charValue,
  computeCheckDigit,
  isValidCheckDigit,
  ISO_COUNTRIES,
  ICAO_SPECIAL_CODES,
  lookupCountry,
  isKnownCountry,
  LAYOUTS,
  fieldDef,
  readField,
  DIGIT_FOR_LETTER,
  LETTERS_FOR_DIGIT,
  resolveCheck,
  checkPasses,
  correctLines
};
//# sourceMappingURL=chunk-YATZMKUB.js.map